module.exports = __webpack_public_path__ + "media/images/regions/Agadez-11d34033e209035399d5247c7651141c.png";